import { MapPin, Calendar, Users } from 'lucide-react';

const StepBasicInfo = ({ formData, handleInputChange }) => {
  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Listing Title *
        </label>
        <input
          type="text"
          required
          className="w-full px-4 py-3 border border-gray-200 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all duration-200 bg-white/50"
          placeholder="Mountain Retreat Experience"
          value={formData.title}
          onChange={(e) => handleInputChange('title', e.target.value)}
        />
        <p className="mt-1 text-xs text-gray-500">
          {formData.title.length.toLocaleString()} characters
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
          <MapPin className="w-4 h-4 text-emerald-600" />
          Location *
        </label>
        <input
          type="text"
          required
          className="w-full px-4 py-3 border border-gray-200 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all duration-200 bg-white/50"
          placeholder="City, Country"
          value={formData.location}
          onChange={(e) => handleInputChange('location', e.target.value)}
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
            <Calendar className="w-4 h-4 text-emerald-600" />
            Start Date *
          </label>
          <input
            type="date"
            required
            className="w-full px-4 py-3 border border-gray-200 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all duration-200 bg-white/50"
            value={formData.startDate}
            onChange={(e) => handleInputChange('startDate', e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
            <Calendar className="w-4 h-4 text-emerald-600" />
            End Date *
          </label>
          <input
            type="date"
            required
            className="w-full px-4 py-3 border border-gray-200 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all duration-200 bg-white/50"
            value={formData.endDate}
            onChange={(e) => handleInputChange('endDate', e.target.value)}
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
          <Users className="w-4 h-4 text-emerald-600" />
          Guest Capacity *
        </label>
        <input
          type="number"
          min="1"
          required
          className="w-full px-4 py-3 border border-gray-200 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all duration-200 bg-white/50"
          placeholder="2"
          value={formData.capacity}
          onChange={(e) => handleInputChange('capacity', e.target.value)}
        />
        <p className="mt-1 text-xs text-gray-500">Maximum number of guests</p>
      </div>
    </div>
  );
};

export default StepBasicInfo;

